module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg39-c56f6dcaa4a113b21eef70d83b885af2.jpg";